import { adminApi } from "./adminClient";

export const fetchAdminEvents = async (params = {}) => {
  const r = await adminApi.get("/admin/events", { params });
  return r.data;
};

export const fetchAdminEvent = async (idOrSlug) => {
  const r = await adminApi.get(`/admin/events/${idOrSlug}`);
  return r.data;
};

export const createAdminEvent = async (payload) => {
  const r = await adminApi.post("/admin/events", payload);
  return r.data;
};

export const updateAdminEvent = async (idOrSlug, payload, { rename_slug } = {}) => {
  const r = await adminApi.put(`/admin/events/${idOrSlug}`, payload, {
    params: rename_slug ? { rename_slug: true } : {},
  });
  return r.data;
};

export const deleteAdminEvent = async (idOrSlug) => {
  const r = await adminApi.delete(`/admin/events/${idOrSlug}`);
  return r.data;
};

// Kopie van een (gearchiveerd) event met een nieuwe datum ("opnieuw plannen").
export const duplicateAdminEvent = async (idOrSlug, { date, end_date = "" }) => {
  const r = await adminApi.post(`/admin/events/${idOrSlug}/duplicate`, { date, end_date });
  return r.data;
};

export const uploadAdminEventPhoto = async (idOrSlug, file) => {
  const form = new FormData();
  form.append("file", file);
  const r = await adminApi.post(`/admin/events/${idOrSlug}/photo`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return r.data;
};

export const EVENT_CATEGORY_OPTIONS = [
  { value: "", label: "Geen" },
  { value: "markt", label: "Markt" },
  { value: "festival", label: "Festival" },
  { value: "cultuur", label: "Cultuur" },
  { value: "watersport", label: "Watersport" },
  { value: "muziek", label: "Muziek" },
  { value: "kinderen", label: "Kinderen" },
  { value: "sport", label: "Sport" },
  { value: "eten-drinken", label: "Eten & Drinken" },
];
